import { useState } from "react";
import { Container, Row, Col } from "reactstrap";
import DisbursalReporting from "./DisbursalReporting";
import CollectionReporting from "./CollectionReporting";
import OverdueReporting from "./OverdueReporting";
import BureauReporting from "./BureauReporting";
import LoanOutstandingReporting from "./LoanOutstandingReporting";
import RecurringReporting from "./RecurringReporting";
import MandateRegistrationReporting from "./MandateRegistrationReporting";
import OverallCollectionReporting from "./OverallCollectionReporting";
import getPrivilegeList from "../PrivilegeList";


const Reporting = () => {
 const privilege = getPrivilegeList();

 const [reports] = useState([
  {
    title: "Disbursal Report",
    subItems: ["Disbursal"],
  },
  {
    title: "Collection Report",
    subItems: ["Collection"],
  },
 {
   title: "Overdue Report",
   subItems: ["Overdue"],
 },
  {
   title: "Bureau Report",
   subItems: ["Bureau"],
 },
   {
   title: "Loan Outstanding Report",
   subItems: ["LoanOutstanding"],
 },
 {
      title: "Recurring Report",
      subItems: ["Mandate Execution" , "Mandate Registration"],
    },
  {
    title: "Overall Collection Report",
    subItems: ["Overall Collection"],
    privilegeKey: "overallCollectionReportView",
  },
].filter((r) => !r.privilegeKey || privilege[r.privilegeKey]));



  const [expandedReport, setExpandedReport] = useState(null);
  const [selectedMainReport, setSelectedMainReport] = useState(null);
  const [selectedSubReport, setSelectedSubReport] = useState(null);

  const handleExpand = (report) => {
    setSelectedMainReport(report.title);
    setSelectedSubReport(null);
    setExpandedReport(expandedReport === report.title ? null : report.title);
  };

  const renderReportContent = () => {
    if (!selectedMainReport && !selectedSubReport) {
      return (
        <p style={{ fontSize: "18px", color: "#6c757d" }}>
          Please select a report to view.
        </p>
      );
    }

    if (selectedMainReport && !selectedSubReport) {
      return (
        <p style={{ fontSize: "18px", color: "#6c757d" }}>
          You selected <strong>{selectedMainReport}</strong>. Please choose a
          sub-report.
        </p>
      );
    }

    switch (selectedSubReport) {
  case "Disbursal":
    return <DisbursalReporting />;
  case "Collection":
    return <CollectionReporting />;
 case "Overdue":
   return <OverdueReporting />;
   case "Bureau":
   return <BureauReporting />;
    case "LoanOutstanding":
   return <LoanOutstandingReporting />;
   case "Mandate Execution": 
        return <RecurringReporting />;
        case "Mandate Registration":
        return <MandateRegistrationReporting />;
        case "Overall Collection":
        return <OverallCollectionReporting />;
  default:
    return (
      <p style={{ fontSize: "16px", color: "#495057" }}>
        Content for <strong>{selectedSubReport}</strong> is coming soon.
      </p>
    );
}
  

  };

  return (
    <>
      <div
        className="header pb-6 pt-4 pt-md-7 mb-4"
        style={{
          background: "linear-gradient(to right, #4facfe, #005bea)", 
        }}
      >
        <Container fluid>
          <Row className="align-items-center">
            <Col>
              <h1 className="text-white m-0 fw-bold">PEDAY</h1>
              <div style={{ height: "10px" }}></div>
              <h3 className="text-white">Reporting Dashboard</h3>
            </Col>
          </Row>
        </Container>
      </div>

      <Container fluid>
        <Row>
          <Col md="3">
            <div
              style={{
                backgroundColor: "#fff",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                padding: "20px",
                maxHeight: "500px",
                overflowY: "auto",
              }}
            >
              {reports.map((report, index) => (
                <div key={index} style={{ marginBottom: "10px" }}>
                  <div
                    onClick={() => handleExpand(report)}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      backgroundColor:
                        expandedReport === report.title ? "#5e72e4" : "transparent",
                      color: expandedReport === report.title ? "#fff" : "#000",
                      fontWeight: "bold",
                      transition: "all 0.2s",
                    }}
                  >
                    {report.title}
                  </div>

                  {expandedReport === report.title && report.subItems.length > 0 && (
                    <div style={{ marginLeft: "15px", marginTop: "8px" }}>
                      {report.subItems.map((sub, subIndex) => (
                        <div
                          key={subIndex}
                          onClick={() => setSelectedSubReport(sub)}
                          style={{
                            padding: "8px",
                            cursor: "pointer",
                            borderRadius: "4px",
                            backgroundColor:
                              selectedSubReport === sub ? "#11cdef" : "transparent",
                            color: selectedSubReport === sub ? "#fff" : "#000",
                            marginBottom: "6px",
                          }}
                        >
                          ➤ {sub}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Col>

          <Col md="9">
            <div
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #dee2e6",
                borderRadius: "10px",
                padding: "25px",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
              }}
            >
              <h4>{selectedSubReport || selectedMainReport || "No Report Selected"}</h4>
              {renderReportContent()}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Reporting;
